export function truncate(str: string, num: number) {
  if (str && str.length <= num) {
    return str;
  }
  return str && str.slice(0, num) + "...";
}



// WEBPACK FOOTER //
// ./src/utils/truncateWord.ts